export default __webpack_public_path__ + "static/AnastasiaPetrova-ce840b57cc59935ca5cea891fbd6027c.png";